// @flow
import * as React from "react"
import { hot } from "react-hot-loader"
import { setHtml } from "../../utils"
import { Container } from "../../components/StyledComponents"
import { tRouteProps, tSiteProps, tContactTemplate } from "../../types"
import { css } from "emotion/macro"
import { color, mq, font } from "../../styles/variables"
import { FlexibleContent } from "../../components/FlexibleContent"
import { PageMeta } from "../../components/PageMeta"

type tContact = any

function Contact(
  props: tContact & tRouteProps & tSiteProps & tContactTemplate
) {
  const { contact } = props.brand
  return (
    <React.Fragment>
      <PageMeta
        title={props.title}
        description={props.contact_page_content.description}
        image={props.brand.logo}
      />
      <div
        className={css`
          padding-bottom: 60px;
          border-bottom: 1px solid #979797;

          ul {
            list-style: none;
          }
        `}
      >
        <Container>
          <figure
            className={css`
              margin-top: 60px;

              h1 {
                line-height: normal;
                font-size: 27px;
                color: #333333;
              }

              img {
                width: 100%;
                display: block;
              }

              figcaption {
                background-color: rgba(0, 0, 0, 0.025);
                padding: 15px 30px;
              }

              ${mq.md(css`
                position: relative;

                figcaption {
                  position: absolute;
                  background-color: ${color.rgb.white[0]};
                  top: 50px;
                  left: 35px;
                  max-width: 280px;
                  padding: 50px 50px 10px;
                }
              `)};
            `}
          >
            <img
              src={props.contact_page_content.map.url}
              alt={props.contact_page_content.map.alt}
            />
            <figcaption {...setHtml(props.contact_page_content.map_content)} />
          </figure>
          <ul
            className={css`
              margin-top: 30px;

              h3 {
                color: ${color.rgb.purple[1]};
                font-weight: normal;
                line-height: normal;
                font-size: 30px;
                margin-bottom: 15px;
                font-family: ${font.family.cursive};
              }

              li {
                border-bottom: 1px solid ${color.rgb.orange[0]};
                padding: 15px 0;

                &:first-of-type {
                  padding-top: 0;
                }
              }

              ${mq.md(css`
                display: flex;
                width: 100%;
                justify-content: space-between;

                li {
                  padding: 0 15px;
                  border-bottom: none;
                  border-left: 1px solid ${color.rgb.orange[0]};
                }
              `)};
            `}
          >
            <li>
              <h3>Phone</h3>
              <div>
                <a href={`tel:${contact.phone.url}`}>{contact.phone.label}</a>
              </div>
            </li>
            <li>
              <h3>E-mail</h3>
              <div>
                <a href={`mailto:${contact.email}`}>{contact.email}</a>
              </div>
            </li>
            <li>
              <h3>Address</h3>
              <div>
                {contact.contact_address.map((item, i) => (
                  <div key={i}>{item.line}</div>
                ))}
              </div>
            </li>
            <li>
              <h3>Prayer Request Line</h3>
              <div>
                <a href={`tel:${contact.prayer_request_line.url}`}>
                  {contact.prayer_request_line.label}
                </a>
              </div>
            </li>
            <li>
              <h3>Inspiration Line</h3>
              <div>
                <a href={`tel:${contact.inspiration_line.url}`}>
                  {contact.inspiration_line.label}
                </a>
              </div>
            </li>
          </ul>
          <div
            className={css`
              text-align: center;
              margin-top: 30px;
            `}
          >
            {props.contact_page_content.description}
          </div>
        </Container>
      </div>
      <Container>
        {props.flexible_content && (
          <FlexibleContent items={props.flexible_content} />
        )}
      </Container>
    </React.Fragment>
  )
}

export default hot(module)(Contact)



// WEBPACK FOOTER //
// /opt/build/repo/src/screens/Page/Contact.js